import { AppPage } from '@/components/AppPage';
import { APP_BY_SLUG } from '@/apps/data';

export function MiDashboard() { return <AppPage app={APP_BY_SLUG['mi-dashboard']} />; }
export function MiEnvioCuba() { return <AppPage app={APP_BY_SLUG['mi-envio-cuba']} />; }
export function MiAdmin() { return <AppPage app={APP_BY_SLUG['mi-admin']} />; }
export function MiCargo() { return <AppPage app={APP_BY_SLUG['mi-cargo']} />; }
export function MiRestaurante() { return <AppPage app={APP_BY_SLUG['mi-restaurante']} />; }
